import React, { useRef, useEffect } from 'react'
import { useTranslation } from 'react-i18next';
import '../Styles/components/customToast.scss';
import { Toast } from 'primereact/toast';

const CustomToast = ({ severity, summary, detail, life = 3000, trigger, handleActionsAfterErrorToast, handleActionsAfterToast, onDismiss, position = "top-right", sticky = false }) => {
    const toast = useRef(null);
    const { t } = useTranslation();

    useEffect(() => {
        if (trigger) {
            const resolvedSummary =
                summary ||
                (severity === 'success'
                    ? t('success')
                    : severity === 'error'
                        ? t('failure')
                        : severity === 'warn'
                            ? t('warning')
                            : severity === 'info'
                                ? t('info')
                                : '');

            const resolvedDetail =
                detail ||
                (severity === 'success'
                    ? t('action-complete')
                    : severity === 'error'
                        ? t('action-error')
                        : '');

            toast?.current?.show({
                severity,
                summary: resolvedSummary,
                detail: resolvedDetail,
                ...(sticky ? { sticky: true } : { life }),
            });
        }

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [trigger, severity, detail, summary, sticky]);

    return <Toast
        ref={toast}
        id="custom-toast"
        className="custom-toast"
        position={position}
        onRemove={(message) => {
            if (message.severity === "success") {
                handleActionsAfterToast?.();
            }
            if (message.severity === "error") {
                handleActionsAfterErrorToast?.();
            }
            onDismiss?.();
        }} />;

}

export default CustomToast